import PropTypes from 'prop-types';
import { useMemo } from 'react';
// material
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
//
import ImageViewer from 'react-simple-image-viewer';
import shape from './shape';
import palette from './palette';
import typography from './typography';
import breakpoints from './breakpoints';
import GlobalStyles from './globalStyles';
import componentsOverride from './overrides';
import shadows, { customShadows } from './shadows';
import { useImagePreviewAuth } from '../context/ImagePreviewContext';
import { useStoryPreviewAuth } from '../context/StoryPreviewContext';
import DiscoverStories from '../components/stories';

// ----------------------------------------------------------------------

ThemeConfig.propTypes = {
  children: PropTypes.node
};

export default function ThemeConfig({ children }) {
  const themeOptions = useMemo(
    () => ({
      palette,
      shape,
      typography,
      breakpoints,
      shadows,
      customShadows
    }),
    []
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);
  const { imageUrls, isViewerOpen, currentImage, closeImageViewer } = useImagePreviewAuth();
  const { storiesOpen } = useStoryPreviewAuth();
  return (
    <>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyles />
          {children}
        </ThemeProvider>
      </StyledEngineProvider>
      {/* This is the image previewer when we click on image in chat */}
      {isViewerOpen && (
        <ImageViewer
          src={imageUrls}
          disableScroll
          currentIndex={currentImage}
          closeOnClickOutside
          backgroundStyle={{
            backgroundColor: 'rgba(0,0,0,0.9)',
            zIndex: 9999
          }}
          onClose={() => closeImageViewer()}
        />
      )}
      {/* Story preview */}
      {storiesOpen && <DiscoverStories />}
    </>
  );
}
